export default __webpack_public_path__ + "static/media/Dashboard.1caeb7cc.svg";